<ng-container matColumnDef="assetId">
  <mat-header-cell [crud-column-header]="columns.column('assetId')" *matHeaderCellDef 
    mat-sort-header cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-tiny" i18n="@@type.Asset.assetId">
      Id 
    </mat-header-cell>
  <mat-cell class="search-column-tiny" *matCellDef="let element" [ngClass]="cellClass(element, 'assetId')">
    {{assetGetter(element)?.assetId}}
  </mat-cell>
</ng-container>

<ng-container matColumnDef="assetType.assetTypeId">
  <mat-header-cell [crud-column-header]="columns.column('assetType.assetTypeId')" *matHeaderCellDef 
    mat-sort-header cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-small" i18n="@@type.Asset.assetType">
      Asset Type 
    </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'assetType.assetTypeId')">
   {{assetGetter(element)?.assetType?.name}}
  </mat-cell>
</ng-container>  

<ng-container matColumnDef="businessUnit.buId">
  <mat-header-cell [crud-column-header]="columns.column('businessUnit.buId')" *matHeaderCellDef mat-sort-header
    cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
    (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag [class]="useBusinessUnitFullDisplay? 'search-column-small' : 'search-column-tiny'"
    i18n="@@type.Asset.businessUnit">
    Business Unit
  </mat-header-cell>
  <mat-cell [class]="useBusinessUnitFullDisplay? 'search-column-small' : 'search-column-tiny'" *matCellDef="let element" [ngClass]="cellClass(element, 'businessUnit')" [matTooltip]="businessUnitFullDisplay(assetGetter(element)?.businessUnit)">
    {{businessUnitDisplay(assetGetter(element)?.businessUnit)}}
  </mat-cell>
</ng-container>

<ng-container matColumnDef="costCentre.ccId">
  <mat-header-cell [crud-column-header]="columns.column('costCentre.ccId')" *matHeaderCellDef 
    mat-sort-header cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    [class]="useBusinessUnitFullDisplay? 'search-column-small' : 'search-column-tiny'" i18n="@@type.Asset.costCentre">
      Cost Centre 
    </mat-header-cell>
  <mat-cell [class]="useBusinessUnitFullDisplay? 'search-column-small' : 'search-column-tiny'" *matCellDef="let element" [ngClass]="cellClass(element, 'costCentre')" [matTooltip]="costCentreFullDisplay(assetGetter(element)?.costCentre)">
    {{costCentreDisplay(assetGetter(element)?.costCentre)}}
  </mat-cell>
</ng-container> 

<ng-container matColumnDef="location">
  <mat-header-cell [crud-column-header]="columns.column('location')" *matHeaderCellDef 
    mat-sort-header cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-small" i18n="@@type.Asset.location">
      Location 
    </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'location')">
    {{assetGetter(element)?.location}}
  </mat-cell>
</ng-container>  

<ng-container matColumnDef="composedAssetClass">
  <mat-header-cell [crud-column-header]="columns.column('composedAssetClass')" *matHeaderCellDef 
    mat-sort-header cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-small" i18n="@@type.Asset.composedAssetClass">
      Composed Asset Class 
    </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'composedAssetClass')">
    {{assetGetter(element)?.composedAssetClass | refDecode:'SYSTEM_COMPOSED_ASSET_CLASS' | async}}
  </mat-cell>
</ng-container>  

<ng-container matColumnDef="createdBy">
  <mat-header-cell [crud-column-header]="columns.column('createdBy')" *matHeaderCellDef mat-sort-header cdkDropList
    cdkDropListLockAxis="x" cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)"
    cdkDrag class="search-column-small" i18n="@@type.Asset.createdBy">
    Created By
  </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'createdBy')">
    {{assetGetter(element)?.createdBy}}
  </mat-cell>
</ng-container>

<ng-container matColumnDef="createdDate">
  <mat-header-cell [crud-column-header]="columns.column('createdDate')" *matHeaderCellDef mat-sort-header cdkDropList
    cdkDropListLockAxis="x" cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)"
    cdkDrag class="search-column-small" i18n="@@type.Asset.createdDate">
    Created Date
  </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'createdDate')">
    {{assetGetter(element)?.createdDate | uimDateTimeFormat}}
  </mat-cell>
</ng-container>

<ng-container matColumnDef="description">
  <mat-header-cell [crud-column-header]="columns.column('description')" *matHeaderCellDef mat-sort-header cdkDropList
    cdkDropListLockAxis="x" cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)"
    cdkDrag class="search-column-small" i18n="@@type.Asset.description">
    Description
  </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'description')">
    {{assetGetter(element)?.description}}
  </mat-cell>
</ng-container>

<ng-container matColumnDef="identityReference">
  <mat-header-cell [crud-column-header]="columns.column('identityReference')" *matHeaderCellDef mat-sort-header
    cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
    (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
    i18n="@@type.Asset.identityReference">
    Identity Reference
  </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'identityReference')">
    {{assetGetter(element)?.identityReference}}
  </mat-cell>
</ng-container>

<ng-container matColumnDef="manufacturer">
  <mat-header-cell [crud-column-header]="columns.column('manufacturer')" *matHeaderCellDef 
    mat-sort-header cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-small" i18n="@@type.Asset.manufacturer">
      Manufacturer 
    </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'manufacturer')">
    {{assetGetter(element)?.manufacturer}}
  </mat-cell>
</ng-container>  

<ng-container matColumnDef="model">
  <mat-header-cell [crud-column-header]="columns.column('model')" *matHeaderCellDef 
    mat-sort-header cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-small" i18n="@@type.Asset.model">
      Model 
    </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'model')">
    {{assetGetter(element)?.model}}
  </mat-cell>
</ng-container>

<ng-container matColumnDef="status">
  <mat-header-cell [crud-column-header]="columns.column('status')" *matHeaderCellDef 
    mat-sort-header cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-small" i18n="@@type.Asset.status">
      Status 
    </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element">
    {{assetGetter(element)?.status | refDecode:'ASSET_STATUS' | async}}
  </mat-cell>
</ng-container>  

<ng-container matColumnDef="tags">
  <mat-header-cell [crud-column-header]="columns.column('tags')" *matHeaderCellDef 
    mat-sort-header cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-medium" i18n="@@type.Asset.tags">
      Tags 
    </mat-header-cell>
  <mat-cell class="search-column-medium" *matCellDef="let element" [ngClass]="cellClass(element, 'tags')">
    {{assetGetter(element)?.tags?.join(", ")}}
  </mat-cell>
</ng-container> 

<ng-container matColumnDef="purchaseDate">
  <mat-header-cell [crud-column-header]="columns.column('purchaseDate')" *matHeaderCellDef mat-sort-header cdkDropList
    cdkDropListLockAxis="x" cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)"
    cdkDrag class="search-column-small" i18n="@@type.Asset.purchaseDate">
    Purchase Date
  </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'purchaseDate')">
    {{assetGetter(element)?.purchaseDate | uimDateFormat}}
  </mat-cell>
</ng-container>

<ng-container matColumnDef="purchasePrice">
  <mat-header-cell [crud-column-header]="columns.column('purchasePrice')" *matHeaderCellDef mat-sort-header cdkDropList
    cdkDropListLockAxis="x" cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)"
    cdkDrag class="search-column-verysmall" i18n="@@type.Asset.purchasePrice">
    Purchase Price
  </mat-header-cell>
  <mat-cell class="search-column-verysmall" *matCellDef="let element" [ngClass]="cellClass(element, 'purchasePrice')">
    {{assetGetter(element)?.purchasePrice | number:'1.0-2':'en-GB'}}
  </mat-cell>
</ng-container>

<ng-container matColumnDef="updatedBy">
  <mat-header-cell [crud-column-header]="columns.column('updatedBy')" *matHeaderCellDef mat-sort-header cdkDropList
    cdkDropListLockAxis="x" cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)"
    cdkDrag class="search-column-small" i18n="@@type.Asset.updatedBy">
    Updated By
  </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'updatedBy')">
    {{assetGetter(element)?.updatedBy}}
  </mat-cell>
</ng-container>

<ng-container matColumnDef="updatedDate">
  <mat-header-cell [crud-column-header]="columns.column('updatedDate')" *matHeaderCellDef mat-sort-header cdkDropList
    cdkDropListLockAxis="x" cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)"
    cdkDrag class="search-column-small" i18n="@@type.Asset.updatedDate">
    Updated Date
  </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'updatedDate')">
    {{assetGetter(element)?.updatedDate | uimDateTimeFormat}}
  </mat-cell>
</ng-container>

<ng-container matColumnDef="comments">
  <mat-header-cell [crud-column-header]="columns.column('comments')" *matHeaderCellDef 
    mat-sort-header cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-medium" i18n="@@type.Asset.comments">
      Comments 
    </mat-header-cell>
  <mat-cell class="search-column-medium" *matCellDef="let element" [ngClass]="cellClass(element, 'comments')" [matTooltip]="assetGetter(element)?.comments">
    {{assetGetter(element)?.comments}}
  </mat-cell>
</ng-container>  

<ng-container matColumnDef="latestRoutineMaintenanceDate">
  <mat-header-cell [crud-column-header]="columns.column('latestRoutineMaintenanceDate')" *matHeaderCellDef 
    cdkDropList cdkDropListLockAxis="x" mat-sort-header
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-small" i18n="@@type.Asset.lastMaintenanceDate">
      Last Maintenance Date 
    </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element">
    {{assetGetter(element)?.latestRoutineMaintenanceDate | uimDateFormat}}
  </mat-cell>
</ng-container>  

<ng-container matColumnDef="nextRoutineMaintenanceRequiredDate">
  <mat-header-cell [crud-column-header]="columns.column('nextRoutineMaintenanceRequiredDate')" *matHeaderCellDef 
    cdkDropList cdkDropListLockAxis="x" mat-sort-header
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-small" i18n="@@type.Asset.nextMaintenanceDate">
      Next Maintenance Date 
    </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element">
    {{assetGetter(element)?.nextRoutineMaintenanceRequiredDate | uimDateFormat}}
  </mat-cell>
</ng-container>  